import React from 'react';
import { loadboardPartners } from '../../data/mock';

const LoadboardMarquee = () => {
  // Double the items for seamless loop
  const doubledPartners = [...loadboardPartners, ...loadboardPartners];

  return (
    <section className="py-16 bg-slate-900/50 border-y border-slate-800/50 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-8">
        <p className="text-center text-slate-400 text-sm font-medium uppercase tracking-wider">
          Works with all your private loadboards
        </p>
      </div>

      {/* Marquee Container */}
      <div className="relative">
        {/* Gradient Masks */}
        <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-slate-950 to-transparent z-10" />
        <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-slate-950 to-transparent z-10" />

        {/* Scrolling Content */}
        <div className="flex animate-marquee">
          {doubledPartners.map((partner, index) => (
            <div
              key={`${partner.id}-${index}`}
              className="flex-shrink-0 mx-8 px-8 py-4 bg-slate-800/30 border border-slate-700/30 rounded-xl hover:bg-slate-800/50 hover:border-sky-500/30 transition-all duration-300 cursor-default"
            >
              <span className="text-slate-300 font-semibold text-lg whitespace-nowrap">
                {partner.name}
              </span>
            </div>
          ))}
        </div>
      </div>

      {/* Second Row - Reverse Direction */}
      <div className="relative mt-6">
        <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-slate-950 to-transparent z-10" />
        <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-slate-950 to-transparent z-10" />

        <div className="flex animate-marquee-reverse">
          {[...doubledPartners].reverse().map((partner, index) => (
            <div
              key={`${partner.id}-reverse-${index}`}
              className="flex-shrink-0 mx-8 px-8 py-4 bg-slate-800/30 border border-slate-700/30 rounded-xl hover:bg-slate-800/50 hover:border-amber-500/30 transition-all duration-300 cursor-default"
            >
              <span className="text-slate-300 font-semibold text-lg whitespace-nowrap">
                {partner.name}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LoadboardMarquee;
